
<div class="alert alert-info">
<h1 class="text-center"> Get Free Math Worksheets</h1>
</div>
<form [formGroup] = "myForm" (ngSubmit)="on_submit()" class="form" enctype="multipart/form-data" >
  <div class="form-group row" [ngClass]="{error:f.curriculum.errors && f.curriculum.touched}">
    <label for="curriculum" class='control-label col-sm-3'>Curriculum<span class="required-asteric">*</span></label>
        <div class="input-group controls col-sm-8">
            <select class="form-control" id="curriculum"  #myCurriculum formControlName="curriculum"
            (change)='loadLevels(myCurriculum.value)'>
                <option *ngFor="let curriculum of curriculums" [value]="curriculum.id">{{curriculum.name}}</option>
            </select>
            <div *ngIf="f.curriculum.errors && f.curriculum.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                <ul>
                    <li>Curriculum  is required.</li>
                </ul>
            </div>
        </div>
</div>


<div class="form-group row" [ngClass]="{error:f.level.errors && f.level.touched}" *ngIf="levels.length>0">
  <label for="level" class='control-label col-sm-3'>Level of Study<span class="required-asteric">*</span></label>
      <div class="input-group controls col-sm-8">
          <select class="form-control" id="level"  #myLevel formControlName="level" (change)='loadTopics(myLevel.value)'>
              <option *ngFor="let level of levels" [value]="level.id">{{level.name}}</option>
          </select>
          <div *ngIf="f.level.errors && f.level.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
              <ul>
                  <li>Level  is required.</li>
              </ul>
          </div>
      </div>
</div>

<div class="form-group row" [ngClass]="{error:f.topic.errors && f.topic.touched}" *ngIf="topics.length>0">
  <label for="topic" class='control-label col-sm-3'>Topic<span class="required-asteric">*</span></label>
      <div class="input-group controls col-sm-8">
          <select class="form-control" id="topic"  #myTopic formControlName="topic" (change)='loadSubTopics(myTopic.value)'>
              <option *ngFor="let topic of topics" [value]="topic.id">{{topic.name}}</option>
          </select>
          <div *ngIf="f.topic.errors && f.topic.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
              <ul>
                  <li>Topic  is required.</li>
              </ul>
          </div>
      </div>
</div>

<div class="form-group row" [ngClass]="{error:f.subTopic.errors && f.subTopic.touched}" *ngIf="subTopics.length>0">
  <label for="subTopic" class='control-label col-sm-3'>subTopic<span class="required-asteric">*</span></label>
      <div class="input-group controls col-sm-8">
          <select class="form-control" id="subTopic"   formControlName="subTopic" >
              <option *ngFor="let subTopic of subTopics" [value]="subTopic.id">{{subTopic.name}}</option>
          </select>
          <div *ngIf="f.subTopic.errors && f.subTopic.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
              <ul>
                  <li>Sub Topic  is required.</li>
              </ul>
          </div>
      </div>
</div>
<div class="text-center">
  <button [disabled]="isSaving" type="submit" class="btn btn-primary mt-3">
    <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
    Submit
  </button>
</div>


</form>
<app-email-form
(submitEmailEvent)="validEmailSubmission($event)"
(closeModalRequest)="closeModal()"></app-email-form>
